import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEN from "./en/translations.json";

//const languages = ['en',]

const resources = {
  en: {
    translations: translationsEN,
  },
};

i18n.use(initReactI18next).init(
  {
    lng: "en",
    fallbackLng: "en",
    resources,
    debug: false,
    ns: ["translations"], // 'override',
    defaultNS: "translations",
    fallbackNS: ["translations"],
    keySeparator: ".",

    interpolation: {
      escapeValue: false,
    },
  },
  (err) => {
    if (err) {
      return;
    }
  },
);

export default i18n;
